// React
import React, { useEffect } from 'react';

// Packages

// Utilities
import { useElseware, useLabels } from 'utilities/hooks';
import { useInitiativeDataStore } from 'utilities/store';

// Components
import { InputWrapper, FormFields } from 'components/_inputs';

const ResultDetails = ({
    fields = null,
    fieldSuffix = '',
    getItemData = () => {},
    initComponent,
    form,
}) => {
    // ///////////////////
    // STORES
    // ///////////////////

    const { utilities } = useInitiativeDataStore();

    // ///////////////////
    // HOOKS
    // ///////////////////

    const { object } = useLabels();
    const { ewUpdate, ewCreate } = useElseware();

    // ///////////////////
    // METHODS
    // ///////////////////

    function getDefaultItemData(formData) {
        const { Description__c, Name__c } = formData;

        // Data for sf
        return {
            Name__c,
            Description__c,
        };
    }

    async function addItem(formData, setValue) {
        try {
            const { data: itemData } = await ewCreate(
                'initiative-result/initiative-result',
                {
                    ...getDefaultItemData(formData),
                    ...getItemData(formData),
                    Type__c: formData?.Choice?.Name,
                    Initiative__c: utilities.initiative.get().Id,
                }
            );

            // Update main data
            utilities.updateInitiativeData('_results', itemData);

            // Update form data
            setValue('Result___Id', itemData?.Id);
        } catch (error) {
            console.log(error);
            return error;
        }
    }

    async function editItem(formData) {
        const { Result___Id } = formData;
        try {
            const {
                data: itemData,
            } = await ewUpdate(
                'initiative-result/initiative-result',
                Result___Id,
                { ...getDefaultItemData(formData), ...getItemData(formData) }
            );

            // Update main data
            utilities.updateInitiativeData('_results', itemData);
        } catch (error) {
            console.log(error);
            return error;
        }
    }

    // ///////////////////
    // FIELDS
    // ///////////////////

    const allFields = [
        {
            type: 'Text',
            name: 'Name__c',
            object: object.config('Initiative_Result__c.Name'),
            maxLength: 200,
        },
        {
            type: 'LongText',
            name: 'Description__c',
            object: object.config(
                `Initiative_Result__c.Description__c${fieldSuffix}`
            ),
            maxLength: 400,
        },
        ...(fields ? fields() : []),
    ];

    // ///////////////////
    // EFFECTS
    // ///////////////////

    useEffect(() => {
        initComponent({
            fields: allFields,
            methods: {
                add: { details: addItem },
                edit: { details: editItem },
            },
        });
    }, []);

    // ///////////////////
    // RETURN
    // ///////////////////

    return (
        <InputWrapper>
            <FormFields
                {...{
                    fields: allFields,
                    form,
                    theme: 'teal',
                }}
            />
        </InputWrapper>
    );
};

export default ResultDetails;
